/* VikingsBrand Viking Name Forge.
   Two modes: "Forge a name" (scholarly, attested) and "What's my Viking name?" (deterministic).
   Deterministic = FNV-1a over the normalised input, so the same input always yields the same
   name. That is what makes a result permalinkable and therefore shareable; a random generator
   produces nothing anyone can send to a friend.
   Renders a share card to canvas in 6 formats and downloads it as a PNG image (never a data file).
   Vanilla JS, no dependencies. Self-inits on DOMContentLoaded. */
(function () {
  'use strict';
  if (window.VBNames) { return; } /* idempotent: never double-boot */

  var DATA = null;
  var BG = {};           /* theme -> { ratio -> HTMLImageElement } */
  var THEME = 'stone';   /* which background set the card renders on */
  var current = null;    /* last generated result */

  /* ---------- Younger Futhark (same map as vb-runes.js MAPS.younger) ---------- */
  var YF = { a:'ᛅ',b:'ᛒ',c:'ᚴ',d:'ᛏ',e:'ᛁ',f:'ᚠ',g:'ᚴ',h:'ᚼ',i:'ᛁ',j:'ᛁ',k:'ᚴ',l:'ᛚ',m:'ᛘ',
             n:'ᚾ',o:'ᚢ',p:'ᛒ',q:'ᚴ',r:'ᚱ',s:'ᛋ',t:'ᛏ',u:'ᚢ',v:'ᚢ',w:'ᚢ',x:'ᚴᛋ',y:'ᛦ',z:'ᛦ' };
  var YF_DI = { th:'ᚦ' };

  /* Characters that do NOT decompose under NFD, so stripping combining marks cannot
     reach them. Everything else (á é í ó ú ü ö ä ñ ç ř ą ę ů ğ ş ...) is handled by the
     NFD pass below and needs no entry here. */
  var HARD = {
    'þ':'th','ð':'d','æ':'ae','ø':'o','œ':'oe','ß':'ss','đ':'d','ħ':'h','ŀ':'l',
    'ł':'l','ı':'i','ŋ':'ng','ſ':'s','ĸ':'k','ƿ':'w','ȝ':'g','µ':'m'
  };
  /* Cyrillic and Greek so a name written in its own script still produces a result. */
  var CYR = {
    'а':'a','б':'b','в':'v','г':'g','д':'d','е':'e','ё':'e','ж':'z','з':'z','и':'i','й':'i',
    'к':'k','л':'l','м':'m','н':'n','о':'o','п':'p','р':'r','с':'s','т':'t','у':'u','ф':'f',
    'х':'h','ц':'c','ч':'c','ш':'s','щ':'s','ъ':'','ы':'y','ь':'','э':'e','ю':'u','я':'a',
    'ђ':'d','ј':'j','љ':'l','њ':'n','ћ':'c','џ':'d','є':'e','і':'i','ї':'i','ґ':'g'
  };
  var GRK = {
    'α':'a','β':'b','γ':'g','δ':'d','ε':'e','ζ':'z','η':'i','θ':'th','ι':'i','κ':'k',
    'λ':'l','μ':'m','ν':'n','ξ':'x','ο':'o','π':'p','ρ':'r','σ':'s','ς':'s','τ':'t',
    'υ':'y','φ':'f','χ':'h','ψ':'ps','ω':'o'
  };

  function foldON(s) {
    var src = String(s == null ? '' : s).toLowerCase();
    var out = '', i;
    for (i = 0; i < src.length; i++) {
      var ch = src.charAt(i);
      if (HARD[ch] !== undefined) { out += HARD[ch]; continue; }
      if (CYR[ch] !== undefined) { out += CYR[ch]; continue; }
      if (GRK[ch] !== undefined) { out += GRK[ch]; continue; }
      out += ch;
    }
    /* NFD then drop combining marks: covers every ordinary Latin accent in one pass
       (á->a, ž->z, č->c, ć->c, š->s, ü->u, ñ->n, ç->c, ğ->g, ą->a ...). */
    if (out.normalize) {
      out = out.normalize('NFD').replace(/[̀-ͯ]/g, '');
    }
    return out;
  }

  /* true when the input yields no Latin letters at all (CJK, Arabic, emoji, digits).
     Such inputs still generate a name (the seed is the raw string) but initial
     matching is meaningless, so we skip straight to the deterministic pick. */
  function hasLetters(s) { return /[a-z]/.test(foldON(s)); }
  function toRunes(raw) {
    var s = foldON(raw).toLowerCase(), out = '', i = 0;
    while (i < s.length) {
      var two = s.substr(i, 2);
      if (YF_DI[two]) { out += YF_DI[two]; i += 2; continue; }
      var ch = s.charAt(i);
      if (ch === ' ') { out += ' '; i++; continue; }
      if (YF[ch]) { out += YF[ch]; }
      i++;
    }
    return out;
  }


  /* dataset src codes -> the titles a reader recognises. The card and the page both use
     these; printing "FORNALDAR, HKR" at a reader is not a citation, it is a filename. */
  var SRC = {
    'Lnb':'Landnámabók','Hkr':'Heimskringla','Nj':'Njáls saga','Eg':'Egils saga',
    'Lax':'Laxdæla saga','Grt':'Grettis saga','Eyr':'Eyrbyggja saga','Gis':'Gísla saga',
    'Hrl':'Hrólfs saga kraka','Edda':'the Poetic Edda','Volsunga':'Völsunga saga',
    'Sturlunga':'Sturlunga saga','Islendingabok':'Íslendingabók','Orkneyinga':'Orkneyinga saga',
    'Ragnars saga':'Ragnars saga loðbrókar','Fornaldar':'the fornaldarsögur',
    'Groenlendinga':'Grœnlendinga saga','Fostbrœðra':'Fóstbrœðra saga',
    'Gunnlaugs saga':'Gunnlaugs saga ormstungu','Kormaks saga':'Kormáks saga',
    'Viga-Glums':'Víga-Glúms saga','Droplaugarsona':'Droplaugarsona saga',
    'Jomsvikinga':'Jómsvíkinga saga','Finnboga':'Finnboga saga','Gautreks':'Gautreks saga',
    'Gesta Danorum':'Gesta Danorum','Njals saga':'Njáls saga','Volsunga saga':'Völsunga saga','Fostbrœðra saga':'Fóstbrœðra saga'
  };
  function srcName(c) { return SRC[c] || c; }

  /* one eyebrow rule, used by the card and by the on-page result */
  function eyebrowFor(res, upper) {
    if (res.mode !== 'fun') { return upper ? 'FORGED IN OLD NORSE' : 'Drawn from the sagas'; }
    var who = String(res.realName || '').trim().replace(/\s+/g, ' ');
    if (who.length > 18) { who = who.split(' ')[0]; }
    if (!who) { return upper ? 'MY VIKING NAME' : 'Your Viking name'; }
    return upper ? (who.toUpperCase() + '’S VIKING NAME') : (who + '’s Viking name');
  }

  /* ---------- deterministic hash (FNV-1a 32-bit) ---------- */
  function fnv1a(str) {
    var h = 0x811c9dc5;
    for (var i = 0; i < str.length; i++) {
      h ^= str.charCodeAt(i);
      h = (h + ((h << 1) + (h << 4) + (h << 7) + (h << 8) + (h << 24))) >>> 0;
    }
    return h >>> 0;
  }
  function pick(arr, seed, salt) {
    if (!arr || !arr.length) { return null; }
    return arr[fnv1a(salt + '|' + seed) % arr.length];
  }

  /* ---------- generation ---------- */
  function normKey(name, day) {
    var raw = String(name == null ? '' : name).trim().toLowerCase().replace(/\s+/g, ' ');
    /* keep digits: stripping them collapsed every numbered input to one seed */
    var latin = foldON(raw).replace(/[^a-z0-9]/g, '');
    /* Fall back to the raw string when folding yields nothing, otherwise every
       non-Latin input (CJK, Arabic, emoji, digits) would collapse to one identical seed. */
    return (latin || raw || 'seidr') + '#' + (day || '');
  }

  /* Old Norse has no c, p, q, w, x or z. Without this ladder every Christopher, Peter,
     William, Xavier and Zoe would fall straight through to an arbitrary pick, which is
     exactly the case where the result stops feeling like it belongs to the user.
     Each substitution is the ordinary Norse reflex of the foreign letter. */
  var PHON = {
    c: ['k', 's'],     /* Latin c -> k (hard) or s (soft) */
    q: ['k'],
    w: ['v', 'u'],     /* w was written u/v */
    x: ['s'],
    z: ['s'],
    p: ['b', 'f'],     /* native p is rare; b is the usual reflex */
    ch: ['k', 'h'],
    ph: ['f'],
    th: ['þ'],
    j: ['i', 'j']
  };

  function initialsFor(realName) {
    var s = String(realName || '').trim().toLowerCase();
    var folded = foldON(s);
    var out = [], two = s.substr(0, 2);
    if (PHON[two]) { out = out.concat(PHON[two]); }
    var raw = s.charAt(0), f = folded.charAt(0);
    if (f) { out.push(f); }
    if (raw && raw !== f) { out.push(raw); }
    if (PHON[f]) { out = out.concat(PHON[f]); }
    /* vowels are interchangeable enough in the corpus to be a decent last resort */
    if ('aeiouyæø'.indexOf(f) >= 0) { out = out.concat(['a', 'e', 'i', 'o', 'u', 'y', 'æ']); }
    return out.filter(function (v, i, a) { return v && a.indexOf(v) === i; });
  }

  /* fun mode: match the given name to the user's real initial where possible.
     Ladder: exact initial -> phonetic reflex -> vowel class -> deterministic fallback.
     Every step stays deterministic, so the result is still permalinkable. */
  function matchInitial(pool, realName, seed) {
    if (!hasLetters(realName)) {
      var only = pick(pool, seed, 'given-nonlatin');
      if (only) { only._match = 'fallback'; }
      return only;
    }
    var cands = initialsFor(realName);
    for (var i = 0; i < cands.length; i++) {
      var c = cands[i];
      var subset = pool.filter(function (e) {
        return foldON(e.on).toLowerCase().charAt(0) === foldON(c).toLowerCase().charAt(0);
      });
      if (subset.length) {
        var hit = pick(subset, seed, 'given-matched-' + c);
        if (hit) { hit._match = (i === 0 ? 'initial' : 'phonetic'); return hit; }
      }
    }
    var fb = pick(pool, seed, 'given-fallback');
    if (fb) { fb._match = 'fallback'; }
    return fb;
  }

  function generate(opts) {
    if (!DATA) { return null; }
    var gender = opts.gender === 'f' ? 'f' : 'm';
    var pool = gender === 'f' ? DATA.given_f : DATA.given_m;
    var byPool = DATA.bynames.filter(function (b) { return b.gender === gender; });
    if (!byPool.length) { byPool = DATA.bynames; }

    var seed, given, byname;
    if (opts.mode === 'fun') {
      seed = normKey(opts.realName, opts.day);
      given = matchInitial(pool, opts.realName, seed);
      byname = pick(byPool, seed, 'byname');
    } else {
      seed = opts.seed || String(fnv1a(String(Math.floor(performance.now() * 1000)) + ':' + pool.length));
      given = pick(pool, seed, 'given');
      byname = opts.withByname === false ? null : pick(byPool, seed, 'byname');
    }
    var full = given.on + (byname ? ' ' + byname.on : '');
    return {
      mode: opts.mode, gender: gender, seed: seed,
      realName: opts.realName || '', day: opts.day || '',
      given: given, byname: byname,
      full: full, runes: toRunes(full)
    };
  }

  /* ---------- share card formats ---------- */
  var FORMATS = [
    { id: 'story',     label: 'Instagram Story',   w: 1080, h: 1920, bg: '9x16', note: 'Stories and Reels' },
    /* Same canvas as the story, different margins. TikTok parks the caption and the
       action rail over the bottom and right of the frame: measured on the story
       render, VIKINGSBRAND.CO sat at y1800 against a safe edge of y1600, so the
       brand mark — the one thing that has to survive — was the part covered.
       safeBottom lifts the block and the footer; safeRight widens the side padding
       so the rune line clears the buttons. */
    { id: 'tiktok',    label: 'TikTok',            w: 1080, h: 1920, bg: '9x16', note: 'Clears caption and buttons', safeBottom: 340, safeRight: 150 },
    { id: 'post',      label: 'Square Post',       w: 1080, h: 1080, bg: '1x1',  note: 'Instagram, Facebook' },
    { id: 'portrait',  label: 'Portrait Post',     w: 1080, h: 1350, bg: '4x5',  note: 'Instagram feed' },
    { id: 'fbcover',   label: 'Facebook Cover',    w: 1640, h: 624,  bg: '21x9', note: 'Page or profile cover' },
    { id: 'wallpaper', label: 'Phone Wallpaper',   w: 1170, h: 2532, bg: '9x16', note: 'iPhone / Android' },
    { id: 'og',        label: 'Link Preview',      w: 1200, h: 630,  bg: '21x9', note: 'X, LinkedIn, WhatsApp' }
  ];

  function drawCover(ctx, img, W, H) {
    if (!img || !img.complete || !img.naturalWidth) {
      var g = ctx.createLinearGradient(0, 0, 0, H);
      g.addColorStop(0, '#171310'); g.addColorStop(1, '#0b0908');
      ctx.fillStyle = g; ctx.fillRect(0, 0, W, H); return;
    }
    var s = Math.max(W / img.naturalWidth, H / img.naturalHeight);
    var dw = img.naturalWidth * s, dh = img.naturalHeight * s;
    ctx.drawImage(img, (W - dw) / 2, (H - dh) / 2, dw, dh);
  }

  function fitText(ctx, text, max, weight, family, start, min) {
    var size = start;
    do {
      ctx.font = weight + ' ' + size + 'px ' + family;
      if (ctx.measureText(text).width <= max) { break; }
      size -= 2;
    } while (size > min);
    return size;
  }

  function renderCard(res, fmt, cb) {
    var c = document.createElement('canvas');
    c.width = fmt.w; c.height = fmt.h;
    var ctx = c.getContext('2d');
    var W = fmt.w, H = fmt.h, wide = W / H > 1.6;

    var set = BG[THEME] || BG.stone || {};
    drawCover(ctx, set[fmt.bg], W, H);

    /* legibility scrim: the card must read at thumbnail size */
    var sc = ctx.createLinearGradient(0, 0, 0, H);
    sc.addColorStop(0, 'rgba(10,8,6,.42)');
    sc.addColorStop(0.45, 'rgba(10,8,6,.62)');
    sc.addColorStop(1, 'rgba(10,8,6,.88)');
    ctx.fillStyle = sc; ctx.fillRect(0, 0, W, H);

    var serif = '"Trirong", Georgia, serif';
    var sans = '"Helvetica Neue", Arial, sans-serif';
    var pad = Math.round(W * (wide ? 0.06 : 0.10));
    /* Formats that declare a safe rail (TikTok) widen the padding instead of
       shifting the block: the layout is centre-aligned, so symmetric padding is
       what actually keeps the longest line clear of the buttons. */
    if (fmt.safeRight) { pad = Math.max(pad, fmt.safeRight); }
    var maxw = W - pad * 2;
    var cx = W / 2;
    var gold = '#d8bc8e', bone = '#f3e9d2', dim = '#c9bda6';

    ctx.textAlign = 'center';

    /* Two-pass layout. Measure the whole block first, then start it so the block is
       optically centred. A fixed start offset left the top 40% of a square card empty. */
    var ebSize = Math.max(13, Math.round(W * (wide ? 0.017 : 0.028)));
    var nameSizeM = fitText(ctx, res.full, maxw, '700', serif,
                            Math.round(W * (wide ? 0.085 : 0.125)), 24);
    var runeSizeM = fitText(ctx, res.runes, maxw, '400',
                            '"Noto Sans Runic","Segoe UI Historic",serif',
                            Math.round(W * (wide ? 0.055 : 0.082)), 18);
    var msM = Math.max(12, Math.round(W * (wide ? 0.019 : 0.031)));
    var ruleGap = Math.round(H * (wide ? 0.055 : 0.042));

    var capSizeM = Math.max(9, Math.round(W * (wide ? 0.011 : 0.019)));

    /* Gaps below the meanings block, as multiples of their own type size. Shared by
       measure() and the draw pass below so the two cannot drift apart. LABEL_GAP was
       1.5, which put the value's ascender ~8px under the label baseline and read as
       one clump; the label needs to sit clear of the line it introduces. */
    var LABEL_GAP = 2.1;   /* label baseline -> its value baseline   (x capSize) */
    var VALUE_GAP = 2.0;   /* given value    -> the next label       (x ms)      */
    var BYNAME_GAP = 1.55; /* byname value   -> the bearer line      (x s2)      */

    function measure() {
      var b = ebSize * 2.4 + nameSizeM * 1.30 + runeSizeM * 1.28 + capSizeM * 2.1
              + ruleGap + capSizeM * LABEL_GAP + msM * VALUE_GAP;
      if (res.byname) {
        b += capSizeM * LABEL_GAP + msM * BYNAME_GAP + Math.round(msM * 0.86) * 1.5;
      }
      return b;
    }
    /* Reserve the footer band up front. Without it the byname bearer line ran straight
       through VIKINGSBRAND.CO on the short wide cards (1640x624). */
    var safeBottom = fmt.safeBottom || 0;
    var footerBand = Math.round(H * (wide ? 0.20 : 0.13)) + safeBottom;
    var avail = H - footerBand;
    var blockH = measure();

    /* If the block still will not fit (very long name on a short card), scale the whole
       block down until it does, rather than letting it overrun the footer. */
    if (blockH > avail) {
      var k = Math.max(0.55, avail / blockH);
      ebSize = Math.max(10, Math.round(ebSize * k));
      nameSizeM = Math.max(18, Math.round(nameSizeM * k));
      runeSizeM = Math.max(14, Math.round(runeSizeM * k));
      msM = Math.max(10, Math.round(msM * k));
      capSizeM = Math.max(8, Math.round(capSizeM * k));
      ruleGap = Math.round(ruleGap * k);
      blockH = measure();
    }

    var y = Math.max(H * 0.05, (avail - blockH) / 2);

    /* eyebrow */
    ctx.fillStyle = gold;
    var eb = ebSize;
    ctx.font = '600 ' + eb + 'px ' + sans;
    /* Name the person on the card. Without this the card is anonymous: you cannot tell
       whose result it is, which is most of what makes it worth sending to someone. */
    var eyebrow = eyebrowFor(res, true);
    ctx.save(); ctx.letterSpacing = Math.round(eb * 0.28) + 'px';
    ctx.fillText(eyebrow, cx, y); ctx.restore();
    y += eb * 2.4;

    /* the name */
    var nameSize = nameSizeM;
    ctx.fillStyle = bone;
    ctx.shadowColor = 'rgba(0,0,0,.65)'; ctx.shadowBlur = Math.round(W * 0.03);
    ctx.font = '700 ' + nameSize + 'px ' + serif;
    ctx.fillText(res.full, cx, y + nameSize * 0.78);
    ctx.shadowBlur = 0;
    y += nameSize * 1.30;

    /* runes */
    var runeSize = runeSizeM;
    ctx.fillStyle = gold;
    ctx.font = '400 ' + runeSize + 'px "Noto Sans Runic", "Segoe UI Historic", serif';
    ctx.save(); ctx.letterSpacing = Math.round(runeSize * 0.14) + 'px';
    ctx.fillText(res.runes, cx, y + runeSize * 0.8); ctx.restore();
    y += runeSize * 1.28;

    /* Say what the runes are. Without this the row reads as decoration. */
    var capSize = capSizeM;
    ctx.font = '600 ' + capSize + 'px ' + sans;
    ctx.fillStyle = 'rgba(216,188,142,.62)';
    ctx.save(); ctx.letterSpacing = Math.round(capSize * 0.24) + 'px';
    ctx.fillText('IN YOUNGER FUTHARK', cx, y); ctx.restore();
    y += capSize * 2.1;

    /* rule */
    ctx.strokeStyle = 'rgba(216,188,142,.45)'; ctx.lineWidth = Math.max(1, W * 0.0016);
    ctx.beginPath(); ctx.moveTo(cx - maxw * 0.14, y); ctx.lineTo(cx + maxw * 0.14, y); ctx.stroke();
    y += ruleGap;

    /* meanings */
    var ms = msM;
    /* Label each half. "Jón: (Christian loan)" alone does not tell you which part is the
       given name and which is the byname, which is the whole point of a Norse name. */
    function label(txt) {
      ctx.font = '600 ' + capSize + 'px ' + sans;
      ctx.fillStyle = 'rgba(216,188,142,.62)';
      ctx.save(); ctx.letterSpacing = Math.round(capSize * 0.2) + 'px';
      ctx.fillText(txt, cx, y); ctx.restore();
      y += capSize * LABEL_GAP;
    }
    label('GIVEN NAME');
    ctx.font = '400 ' + ms + 'px ' + serif;
    ctx.fillStyle = bone;
    var l1 = res.given.on + ': ' + res.given.meaning;
    fitText(ctx, l1, maxw, '400', serif, ms, 11);
    ctx.fillText(l1, cx, y); y += ms * VALUE_GAP;
    if (res.byname) {
      label('BYNAME');
      ctx.fillStyle = dim;
      ctx.font = '400 ' + ms + 'px ' + serif;
      var l2 = res.byname.on + ': ' + res.byname.meaning;
      var s2 = fitText(ctx, l2, maxw, '400', serif, ms, 11);
      ctx.fillText(l2, cx, y); y += s2 * BYNAME_GAP;
      var l3 = 'borne by ' + res.byname.bearer;
      var s3 = fitText(ctx, l3, maxw, '400', serif, Math.round(ms * 0.86), 10);
      ctx.fillStyle = 'rgba(201,189,166,.78)';
      ctx.fillText(l3, cx, y); y += s3 * 1.5;
    }

    /* footer */
    var fs = Math.max(11, Math.round(W * (wide ? 0.014 : 0.023)));
    ctx.font = '600 ' + fs + 'px ' + sans;
    ctx.fillStyle = 'rgba(216,188,142,.92)';
    ctx.save(); ctx.letterSpacing = Math.round(fs * 0.22) + 'px';
    ctx.fillText('VIKINGSBRAND.CO', cx, H - Math.round(H * (wide ? 0.10 : 0.062)) - safeBottom);
    ctx.restore();

    c.toBlob(function (blob) { cb(blob, c); }, 'image/png');
  }

  /* lightweight usage tracking: fires to whatever analytics is already on the page (GA4 / GTM dataLayer / Shopify).
     No-op and never throws if no analytics is present. Real, honest counts, visible to the store owner only.
     Same shape as vbTrack in vb-runes.js so the two tools are directly comparable in GA4. */
  function vbTrack(action, extra) {
    try {
      var d = { tool: 'name-generator', vb_action: action };
      if (extra) { if (extra.mode) d.mode = extra.mode; if (extra.gender) d.gender = extra.gender; if (extra.format) d.format = extra.format; }
      if (window.gtag) window.gtag('event', 'name_' + action, d);
      if (window.dataLayer && window.dataLayer.push) { var g = { event: 'name_' + action }; for (var k in d) g[k] = d[k]; window.dataLayer.push(g); }
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) window.Shopify.analytics.publish('name_' + action, d);
      /* Broadcast so add-on layers (the public counter in vb-names-refresh.js) see
         every action. Dispatching here rather than wrapping the exported track()
         is what makes this a real choke point: downloadCard and shareCard call the
         local vbTrack directly and would slip past any wrapper on the export. */
      document.dispatchEvent(new CustomEvent('vb:name-action', { detail: d }));
    } catch (e) {}
  }

  /* download as an IMAGE, not a file blob the OS treats as data */
  function downloadCard(res, fmt) {
    vbTrack('download', { mode: res.mode, gender: res.gender, format: fmt.id });
    renderCard(res, fmt, function (blob) {
      var url = URL.createObjectURL(blob);
      var a = document.createElement('a');
      a.href = url;
      a.download = 'viking-name-' + foldON(res.full).toLowerCase().replace(/[^a-z0-9]+/g, '-')
                   + '-' + fmt.id + '.png';
      document.body.appendChild(a); a.click(); a.remove();
      setTimeout(function () { URL.revokeObjectURL(url); }, 4000);
    });
  }

  /* The permalink, tagged so the visits a shared card produces can be told apart
     from the rest. We already count shares (name_share); this counts what they
     bring back, which is the half that decides whether the card is worth anything.
     Existing utm_* are stripped first: someone who arrived from a shared card and
     shares onward would otherwise compound the parameters on every hop.
     The page's canonical is the clean URL, so tagged copies cannot fragment it. */
  function shareUrl(medium) {
    try {
      var u = new URL(location.href);
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term']
        .forEach(function (k) { u.searchParams.delete(k); });
      u.searchParams.set('utm_source', 'namecard');
      u.searchParams.set('utm_medium', medium);
      return u.toString();
    } catch (e) { return location.href; }
  }

  function shareCard(res, fmt) {
    vbTrack('share', { mode: res.mode, gender: res.gender, format: fmt.id });
    renderCard(res, fmt, function (blob) {
      var file = new File([blob], 'viking-name.png', { type: 'image/png' });
      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        /* The link goes in `text`, not in `url`. The caption ends on a colon, so
           the link has to arrive with it — and this shipped with no `url` at all,
           which is why WhatsApp showed "Find yours:" followed by nothing.
           Passing `url` alongside `files` is not a reliable fix: targets that take
           a file generally use `text` as the caption and are free to drop `url`,
           and the ones that honour both would print the link twice. Folding it
           into the caption puts it there exactly once, everywhere.
           location.href is the permalink toUrl() just wrote, so the recipient
           opens the same name rather than a blank tool. */
        navigator.share({
          files: [file],
          title: res.full,
          text: 'My Viking name is ' + res.full + '. Find yours: ' + shareUrl('social')
        }).catch(function () {});
      } else {
        downloadCard(res, fmt);
      }
    });
  }

  window.VBNames = {
    generate: generate, toRunes: toRunes, fnv1a: fnv1a,
    FORMATS: FORMATS, renderCard: renderCard,
    downloadCard: downloadCard, shareCard: shareCard,
    setData: function (d) { DATA = d; }, getData: function () { return DATA; },
    setBg: function (theme, k, img) { if (!BG[theme]) { BG[theme] = {}; } BG[theme][k] = img; },
    setTheme: function (t) { THEME = t; }, getTheme: function () { return THEME; },
    eyebrowFor: eyebrowFor, srcName: srcName, track: vbTrack, shareUrl: shareUrl,
    THEMES: [
      { id: 'stone',  label: 'Runestone' },
      { id: 'ship',   label: 'Longship' },
      { id: 'forge',  label: 'Forge' }
    ],
    setCurrent: function (r) { current = r; }, getCurrent: function () { return current; }
  };
})();
